import { bootstrapApplication } from '@angular/platform-browser';
import { CustomerAppComponent } from './customer-app.component';
import { customerAppConfig } from './customer-app.config';

bootstrapApplication(CustomerAppComponent, customerAppConfig)
  .catch((err) => console.error(err)); 